import {
  AnimationFormData,
  BossAnimation,
  BossSkill,
  MotionType,
} from "../types";

export interface MotionGroup {
  key: string;
  ownerCode: string;
  actionKey: string;
  name: string;
  missingSkill: boolean;
  records: BossAnimation[];
}

const basicActions: Record<string, string> = {
  idle: "대기",
  death: "사망",
  hit: "피격",
  interrupted: "시전 중단",
};
export function buildMotionGroups(
  ownerCode: string,
  skills: BossSkill[],
  animations: BossAnimation[],
): MotionGroup[] {
  const ownSkills = skills.filter((s) => s.boss_code === ownerCode);
  const records = animations.filter((a) => a.boss_code === ownerCode);
  const keys = Array.from(
    new Set([
      "idle",
      "death",
      ...ownSkills.map((s) => s.key),
      ...records.map((a) => a.action_type),
    ]),
  );
  return keys.map((actionKey) => {
    const skill = ownSkills.find((s) => s.key === actionKey);
    return {
      key: JSON.stringify([ownerCode, actionKey]),
      ownerCode,
      actionKey,
      name: skill?.name || basicActions[actionKey] || "연결 확인 필요",
      missingSkill: !skill && !basicActions[actionKey],
      records: records
        .filter((a) => a.action_type === actionKey)
        .slice()
        .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)),
    };
  });
}

export function assetStatus(
  value: boolean | null | undefined,
  required = false,
) {
  if (value === true) return "완료";
  if (value === false) return "준비 중";
  return value === null && !required ? "불필요" : "미설정";
}
export function motionPending(group: MotionGroup) {
  return (
    !group.records.length ||
    group.records.some(
      (a) =>
        a.has_animation !== true ||
        a.has_sound_effect === false ||
        a.has_vfx === false ||
        a.has_sound_effect === undefined ||
        a.has_vfx === undefined,
    )
  );
}
const editableFields = [
  "motion_type",
  "montage_name",
  "has_animation",
  "has_sound_effect",
  "has_vfx",
] as const;
export function motionPatch(
  original: BossAnimation,
  values: Partial<AnimationFormData>,
): Partial<AnimationFormData> {
  return Object.fromEntries(
    editableFields
      .filter(
        (key) =>
          Object.prototype.hasOwnProperty.call(values, key) &&
          values[key] !== original[key],
      )
      .map((key) => [key, values[key]]),
  );
}
export function newMotion(
  group: MotionGroup,
  values: Partial<AnimationFormData>,
): AnimationFormData {
  return {
    boss_code: group.ownerCode,
    action_type: group.actionKey,
    motion_type: values.motion_type || MotionType.BASIC,
    montage_name: values.montage_name || "",
    has_animation: values.has_animation ?? false,
    has_sound_effect: values.has_sound_effect ?? null,
    has_vfx: values.has_vfx ?? null,
    sort_order: Math.max(0, ...group.records.map((r) => r.sort_order || 0)) + 1,
  };
}
